// extracted by mini-css-extract-plugin
export var dropdownContainer = "_q2-0";
export var leftAlign = "_q2-4";
export var listItem = "_q2-2";
export var listItemWrapper = "_q2-1";
export var operationText = "_q2-3";